/**
 * Chat writes authenticate with the ivy-chat session token in localStorage, not the Firebase
 * token. A token outlives an account switch in the same browser, so it is only reused when it
 * was minted for the account now signed in; otherwise every send goes out as the old account
 * and ivy-chat answers "Session not found".
 */
export function sessionBelongsTo(
  sessionUser: { email: string } | undefined,
  firebaseEmail: string | null | undefined,
): boolean {
  const a = sessionUser?.email?.trim().toLowerCase();
  const b = firebaseEmail?.trim().toLowerCase();
  return !!a && !!b && a === b;
}
